import React from 'react'
import UbigeoFieldFilter from '../../../molecules/fields/UbigeoFieldFilter'
import useUserPermission from '../../../../hooks/useUserPermission'
import FormTypeFilter from '../field_filter/FormTypeFilter'
import DateRangeField from '../../../molecules/fields/DateRangeField'
import TextField from '../../../molecules/fields/TextField'
import MyBranchOfficeFilter from '../../filters/MyBranchOfficeFilter'
import InstitutionTypeFieldFilter from '../../../molecules/fields/InstitutionTypeFieldFilter'
import CollaboratorFilter from '../field_filter/CollaboratorFilter'

const AttendedRequestsFilters = () => {
  const { canSeeInstitutionFilter, canSeeBranchOfficeFilter } = useUserPermission('statistics')

  return (
    <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-4">
      <div className="flex flex-col gap-6">
        <FormTypeFilter />
        <TextField name="attended_search_name" label="Nombre o ID de formulario" margin="none" />
        <CollaboratorFilter />
      </div>
      {canSeeInstitutionFilter && (
        <>
          <div className="flex flex-col">
            <InstitutionTypeFieldFilter name="attended_request" showInstitutions showMunicipalityType />
          </div>
          <div className="flex flex-col gap-5">
            <UbigeoFieldFilter name="attended" />
          </div>
        </>
      )}
      {canSeeBranchOfficeFilter && <MyBranchOfficeFilter />}
      <DateRangeField
        name="attended_date"
        label="Rango de solicitudes recibidas"
        labelClassName="flex flex-col gap-3"
      />
    </div>
  )
}

export default AttendedRequestsFilters
